import React, { Fragment, useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, CardBody } from "react-bootstrap";

import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
// import { connect } from 'react-redux';
// import { submitForm } from './redux/actions/actions';
import Cookies from 'js-cookie';
import CookieConsent from "../../CookieConsent";
import { loadSanadBranding } from '../utils/loadSanadBranding';

const { config } = require('../../api/api');


const SanadVisaIframe = () => {
 
    const base_url = config.baseURL;

  const [deepLink, setDeepLink] = useState('');
  
    const vendorKey = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';

 useEffect(() => {

    loadSanadBranding();

  }, []);

  useEffect(() => {
    const deepLinkString = sessionStorage.getItem('deeplink');
    if (deepLinkString) {
      const deepLinkSearch = JSON.parse(deepLinkString);

      var link = deepLinkSearch?.result?.iframe_deeplink_url;
      setDeepLink(link);
    }
  }, []);




  useEffect(() => {
    // debugger
    // Listen for postMessage from the iframe
    const messageListener = (event) => {
      // debugger
      if (event?.data?.type === 'formSubmitted') {

        fetch(base_url+"/update_sanad_application_status",{
          method:"POST",
          headers:{
            "Authorization":"Bearer "+vendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify({order_id:event?.data?.orderId,application_status:"success"})
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            sessionStorage.setItem("event_data", JSON.stringify(event?.data));
        // window.location.href = '/sanad-visa-payment?order_id='+event?.data?.orderId;
        window.location.href = '/sanadvisapayment?order_id='+event?.data?.orderId;  //amwalpay
        
          }
        }).catch(err=>console.error("while updating application status err : "+err))
       
     
      }
    };

    window.addEventListener('message', messageListener);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);







  return (

    <Fragment>

      {/* Other components */}
      <CookieConsent />

      <div style={{ margin: 0, padding: 0 }}>
        <iframe
          id="visaApplicationForm"
          src={deepLink}
          title="Visa"
          style={{
            width: '100vw',
            height: '100vh',
            border: 'none',
            display: 'block', // Removes the iframe's bottom gap
          }}
        />

      </div>
      <div id="nextStep" style={{ display: 'none' }}>
        {/* Content for the next step */}
        <h2>Payment Setup</h2>
        {/* More content here */}
      </div>

    </Fragment>
  );

};

export default SanadVisaIframe;